document.addEventListener("DOMContentLoaded", function () {
  const now = new Date();
  const currentHour = now.getHours();

  const shippingElement = document.querySelector(".m-product-shipping--content");

  if (shippingElement) {
    let message = "";

    if (currentHour < 12) {
      message = '<p style="color: #666666"><strong>Fast Dispatch:</strong> Same-Day Shipping</p>';
    } else {
      message = '<p style="color: #666666"><strong>Fast Dispatch:</strong> Next Day</p>';
    }

    shippingElement.innerHTML = message;
  }
});







document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("spiritual-popup-overlay");
  const popup = document.getElementById("spiritual-popup");
  const closeBtn = document.getElementById("spiritual-close-btn");

  let popupShown = false;

  function showPopup() {
    if (!overlay || !popup) return;
    if (popupShown || sessionStorage.getItem("spiritualPopupShown")) return;

    popupShown = true;
    sessionStorage.setItem("spiritualPopupShown", "true");

    overlay.classList.add("active");
    overlay.setAttribute("aria-hidden", "false");
    document.body.classList.add("spiritual-popup-open");
  }

  function closePopup() {
    if (!overlay) return;
    overlay.classList.remove("active");
    overlay.setAttribute("aria-hidden", "true");
    document.body.classList.remove("spiritual-popup-open");
  }

  setTimeout(showPopup, 8000);

  if (closeBtn) closeBtn.addEventListener("click", closePopup);

  if (overlay) {
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closePopup();
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay && overlay.classList.contains("active")) {
      closePopup();
    }
  });
});



/* 
====================================================
AOP – Make Entire Product Card Clickable
----------------------------------------------------
- Makes whole product card open product page
- Does NOT interfere with:
  • Add to Cart
  • Wishlist
  • Review stars
  • Quickview
- Uses event delegation (1 global listener)
- Extremely lightweight (no performance impact)
====================================================
*/

document.addEventListener("click", function (e) {


  if (
    e.target.closest(
      "a, button, input, select, textarea, [role='button'], .m-product-card__action, .jdgm-widget"
    )
  ) {
    return;
  }


  const card = e.target.closest(".m-product-card[data-product-url]");
  if (!card) return;

  const url = card.getAttribute("data-product-url");
  if (!url) return;


  if (e.ctrlKey || e.metaKey) {
    window.open(url, "_blank");
  } else {
    window.location.href = url;
  }
});